import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var getOverridenAgents = function getOverridenAgents(agents, agentIdFiltersOverride, agentDefaultIdOverride) {
  var defaultOverrideAgentsIndex = agents.findIndex(function (agent) {
    return agentDefaultIdOverride === agent.id;
  });
  var overridenAgents = [];
  if (defaultOverrideAgentsIndex !== -1) {
    overridenAgents = agents.map(function (agent, index) {
      return _objectSpread(_objectSpread({}, agent), {}, {
        is_default: index === defaultOverrideAgentsIndex
      });
    });
  } else {
    overridenAgents = agents;
  }
  if (Array.isArray(agentIdFiltersOverride)) {
    return overridenAgents.filter(function (agent) {
      return (agentIdFiltersOverride === null || agentIdFiltersOverride === void 0 ? void 0 : agentIdFiltersOverride.includes(agent.id)) || agent.is_default;
    });
  }
  return overridenAgents;
};